import React from 'react';
import { Link, Box } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import DeleteWithIcon from '../components/team/DeleteWithIcon';

export const snapshotColumns = (getSnapshotList, handleRowClick) => [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    renderCell: (params) =>
      params.row ? (
        <Link
          component={RouterLink}
          to={`/snapshots/details/${params?.row?.name}`}
          underline="none"
        >
          {params.row?.name}
        </Link>
      ) : (
        'n/a'
      )
  },
  { field: 'description', headerName: 'Description', flex: 1 },
  {
    field: 'type',
    headerName: 'Type',
    flex: 0.75,
    valueGetter: (params) => (params?.row?.name?.startsWith('pk') ? 'Baseline PACOS' : 'Custom')
  },
  {
    field: 'baseline',
    headerName: 'Baseline Release',
    flex: 1,
    valueGetter: (params) =>
      params?.row?.name?.split('-')[0]?.includes('pk')
        ? params.row?.rack_details?.loading_history?.kits?.[0]?.kit?.fileId
        : 'Undefined'
  },
  {
    field: 'database',
    headerName: 'Baseline Database PN',
    flex: 1,
    valueGetter: (params) => {
      if (params?.row?.name?.split('-')[0]?.includes('pk')) {
        const dbPN = params.row?.name?.split('-')[1];
        return dbPN?.padStart(8, '0') || 'Undefined';
      }
      return 'Undefined';
    }
  },
  {
    field: 'system_type',
    headerName: 'System Type',
    flex: 0.75,
    valueGetter: (params) => params?.row?.rack_details?.system_type || 'ife'
  },
  {
    field: 'size',
    headerName: 'Snapshot Size',
    flex: 0.75,
    valueGetter: (params) => params?.row?.rack_details?.gateway?.size || 'small'
  },
  {
    field: 'provisioner_identity',
    headerName: 'Team Name',
    flex: 1,
    renderCell: (params) => params?.row?.provisioner_identity || 'Global'
  },
  {
    field: 'actions',
    headerName: '',
    sortable: false,
    flex: 0.5,
    renderCell: (param) => (
      <Box sx={{ textAlign: 'right', width: '100%' }}>
        <DeleteWithIcon
          type="icononly"
          variant="contained"
          data={param.row?.name}
          onDeleted={getSnapshotList}
          title={`Delete Snapshot (${param.row?.name})`}
          content="Are you sure you wish to delete the Snapshot?"
          toolTipTitle="Delete Snapshot"
          snackBarSuccessMessage="Snapshot delete request successful"
          snackBarFailureMessage="Snapshot delete request failed"
          endpoint={`/racks/snapshot/${param.row?.name}`}
          onRowClick={handleRowClick}
        />
      </Box>
    )
  }
];
